import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Button,
  Card,
  CardContent,
  TextField,
  Typography,
  Alert,
  Stack,
} from '@mui/material';
import SchoolIcon from '@mui/icons-material/School';
import DescriptionIcon from '@mui/icons-material/Description';
import FlagIcon from '@mui/icons-material/Flag';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';

function CourseCreationPage() {
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [objectives, setObjectives] = useState('');
  const [duration, setDuration] = useState('');
  const [certification, setCertification] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const token = localStorage.getItem('token');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!title || !description || !objectives || !duration || !certification) {
      setError('All fields are required.');
      return;
    }

    try {
      const res = await fetch('http://196.216.9.34:5020/api/courses', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          title,
          description,
          objectives,
          duration,
          certification,
        }),
      });

      const data = await res.json();
      if (!res.ok) throw new Error(data.message || 'Failed to create course');

      alert('Course created successfully!');
      navigate('/dashboard');
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      minHeight="100vh"
      p={2}
      sx={{
        background: `linear-gradient(135deg, #4278f5, #ffffff, #e3f2fd)`,
        backgroundSize: '400% 400%',
        animation: 'gradientBG 15s ease infinite',
        '@keyframes gradientBG': {
          '0%': { backgroundPosition: '0% 50%' },
          '50%': { backgroundPosition: '100% 50%' },
          '100%': { backgroundPosition: '0% 50%' },
        },
        backgroundAttachment: 'fixed',
      }}
    >

      <Card sx={{ width: '100%', maxWidth: 500, borderRadius: 3, boxShadow: 4 }}>
        <CardContent>
          <Stack spacing={3} component="form" onSubmit={handleSubmit}>
          <Typography
            variant="h4"
            fontWeight="bold"
            style={{ backgroundColor: "#ff6600", borderRadius: "18px", color: "white" }}
            sx={{
              px: 3,
              py: 1,
              textAlign: "center",
              mx: "auto", // centers the block horizontally
              display: "inline-block", // shrink-wrap the content
            }}
          >
            Create New Course
          </Typography>


            {error && <Alert severity="error">{error}</Alert>}

            <TextField
              label="Course Title"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              fullWidth
              required
              InputProps={{
                startAdornment: <SchoolIcon color="primary" sx={{ mr: 1 }} />,
              }}
            />

            <TextField
              label="Course Description"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              multiline
              rows={3}
              fullWidth
              required
              InputProps={{
                startAdornment: <DescriptionIcon color="primary" sx={{ mr: 1, mt: 1 }} />,
              }}
            />

            <TextField
              label="Objectives"
              value={objectives}
              onChange={(e) => setObjectives(e.target.value)}
              multiline
              rows={3}
              fullWidth
              required
              InputProps={{
                startAdornment: <FlagIcon color="primary" sx={{ mr: 1, mt: 1 }} />,
              }}
            />

            <TextField
              label="Duration (e.g. 6 weeks)"
              value={duration}
              onChange={(e) => setDuration(e.target.value)}
              fullWidth
              required
              InputProps={{
                startAdornment: <AccessTimeIcon color="primary" sx={{ mr: 1 }} />,
              }}
            />

            <TextField
              label="Certification (e.g. Certificate of Completion)"
              value={certification}
              onChange={(e) => setCertification(e.target.value)}
              fullWidth
              required
              InputProps={{
                startAdornment: <EmojiEventsIcon color="primary" sx={{ mr: 1 }} />,
              }}
            />


            <Button type="submit" variant="contained" color="primary" fullWidth sx={{ py: 1.5 }}>
              Create Course
            </Button>
          </Stack>
        </CardContent>
      </Card>
    </Box>
  );
}

export default CourseCreationPage;
